import React, {} from "react";
import { useSelector } from "react-redux";
import "./menu.css";
// Components
import ButtonNew from "../../common/buttonNew";
import ButtonDetail from "../../common/buttonDetail";
import ButtonEdit from "../../common/buttonEdit";
import ButtonDelete from "../../common/buttonDelete";
import ButtonRefresh from "../../common/buttonRefresh";

const MaintenanceViewMenu = ({ 
  primaryKey,
  primaryNameKey,
  config, 
  reducerName, 
  setRefreshData,
  itemNameSingular,
  itemIsMale,
  onDelete,
  defaultDetailPathKey,
  page,
}) => {
  // Selectors
  const selectedRows = useSelector((state) => state[reducerName].selectedRows);

  const primaryValue = selectedRows.length > 0 ? selectedRows[0][primaryKey] : "";
  const primaryName = selectedRows.length > 0 ? selectedRows[0][primaryNameKey] : "";
  const previousChildren = !!config.previousChildren ? config.previousChildren : [];
  const nextChildren = !!config.nextChildren ? config.nextChildren : [];

  // Detail/Edit should only be enabled with exactly one selected row.
  let buttonDetailDisabled = selectedRows.length !== 1;
  let buttonEditDisabled = selectedRows.length !== 1;
  if (!!config.buttonEdit && config.buttonEdit.alwaysEnabled && selectedRows.length <= 1) {
    buttonEditDisabled = false;
  }

  return (
      <div id="maintenance-view-menu">
        {previousChildren}
        <ButtonNew config={config.buttonNew} page={page} itemNameSingular={itemNameSingular} itemIsMale={itemIsMale} onNewAddStringAtEndOfPath={config.onNewAddStringAtEndOfPath} />
        <ButtonDetail primaryValue={primaryValue} primaryName={primaryName} config={{...config.buttonDetail, marginLeft: "5px", disabled: buttonDetailDisabled }} itemNameSingular={itemNameSingular} defaultDetailPathKey={defaultDetailPathKey} page={page} />
        <ButtonEdit primaryValue={primaryValue} primaryName={primaryName} config={{...config.buttonEdit, marginLeft: "5px", disabled: buttonEditDisabled }} page={page} itemNameSingular={itemNameSingular} onEditAddStringAtEndOfPath={config.onEditAddStringAtEndOfPath} />
        <ButtonDelete primaryValue={primaryValue} primaryName={primaryName} selectedRows={selectedRows} config={{...config.buttonDelete, marginLeft: "5px", disabled: selectedRows.length === 0 }} itemNameSingular={itemNameSingular} itemIsMale={itemIsMale} onDelete={onDelete} />
        <ButtonRefresh config={{...config.buttonRefresh, marginLeft: "5px" }} setRefreshData={setRefreshData} />
        {nextChildren}
      </div>
  );
};

export default MaintenanceViewMenu;
